import React from "react";

const EmptyState = () => {
  return (
    <div className="card-board p-8 text-center">
      <h3 className="heading-display text-lg mb-2">No averages found</h3>
      <p className="text-brand-muted">
        No bowler averages found for this tournament.
      </p>
    </div>
  );
};

export default EmptyState;
